module.exports = __webpack_public_path__ + "img/4_quality_education_color.e0a323c8.svg";